import i18next from 'i18next';
import { useTranslation as usei18nextTranslation } from 'react-i18next';

const NAMESPACE = 'INITIAL_POPUPS';

i18next.addResources('es', NAMESPACE, {
  ERROR_GET_NEW_FEATURES: 'Error al obtener las nuevas actualizaciones',
  ERROR_ACCEPT_TERMS_AND_CONDITIONS: 'Error al aceptar los términos y condiciones',
  ERROR_BROWSER_SUPPORT: 'Ups! 😵‍💫 Parece que tu navegador es algo viejo para usar Humand. Te pedimos que actualices tu navegador y vuelvas a intentar.',
});

i18next.addResources('en', NAMESPACE, {
  ERROR_GET_NEW_FEATURES: 'Error getting new updates',
  ERROR_ACCEPT_TERMS_AND_CONDITIONS: 'Error accepting the terms and conditions',
  ERROR_BROWSER_SUPPORT: 'oops! 😵‍💫 It seems that your browser is too old to use Humand. We ask that you refresh your browser and try again.',
});

i18next.addResources('pt', NAMESPACE, {
  ERROR_GET_NEW_FEATURES: 'Erro ao obter novas atualizações',
  ERROR_ACCEPT_TERMS_AND_CONDITIONS: 'Erro ao aceitar os termos e condições',
  ERROR_BROWSER_SUPPORT: 'opa! 😵‍💫 Parece que seu navegador é muito antigo para usar o Humand. Pedimos que atualize seu navegador e tente novamente.',
});

export const useTranslation = () => usei18nextTranslation([NAMESPACE, 'GENERAL']);
